import { render } from "./DepositPaymentMethods.vue?vue&type=template&id=4509f4f0"
import script from "./DepositPaymentMethods.vue?vue&type=script&lang=js"
export * from "./DepositPaymentMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__